<template>
  <div class="wrapper">
    <div class="list">
      <div
        class="row"
        v-for="(item, idx) in lstFiveStallSell"
        :key="idx"
        @click="buySaleClick(item)"
      >
        <div class="cell">卖{{ 5 - idx }}</div>
        <div :class="['cell', item && item.price > lastclose ? 'c1' : 'c3']">
          {{ zxjFormat(item) }}
        </div>
        <div class="cell">{{ countFormat(item) }}</div>
      </div>
    </div>
    <div class="list-split"></div>
    <div class="list">
      <div
        class="row"
        v-for="(item, idx) in lstFiveStallBuy"
        :key="idx"
        @click="buySaleClick(item)"
      >
        <div class="cell">买{{ 5 - idx }}</div>
        <div :class="['cell', item && item.price > lastclose ? 'c1' : 'c3']">
          {{ zxjFormat(item) }}
        </div>
        <div class="cell">{{ countFormat(item) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFiveStall } from '@/api/AuthorJinNang'

export default {
  name: 'AuthorJinNangFiveSaleAndBuy',
  components: {},
  data() {
    return {
      lstFiveStallRes: {},
      getinterval: null
    }
  },
  props: {
    stockid: {
      type: Number,
      required: true
    },
    isJJ: {
      type: Boolean,
      require: true
    },
    lastclose: {
      type: Number,
      require: true
    }
  },
  mounted() {
    var that = this
    this.getinterval = setInterval(() => {
      that.getFiveStallRes()
    }, 10000)
  },
  watch: {
    stockid(newvalue, oldValue) {
      this.getFiveStallRes()
    }
  },
  computed: {
    lstFiveStallBuy() {
      if (this.lstFiveStallRes && this.lstFiveStallRes.buying) {
        return this.lstFiveStallRes.buying.slice(0, 5).map(a => ({
          price: a.price,
          volume: parseInt(a.volume)
        }))
      }
      return new Array(5)
    },
    lstFiveStallSell() {
      if (this.lstFiveStallRes && this.lstFiveStallRes.selling) {
        return this.lstFiveStallRes.selling
          .slice(0, 5)
          .map(a => ({
            price: a.price,
            volume: parseInt(a.volume)
          }))
          .reverse()
      }
      return new Array(5)
    }
  },
  methods: {
    async getFiveStallRes() {
      if (this.stockid) {
        const response = await getFiveStall({
          goods_id: this.stockid,
          goods_time: 0,
          market_bets: 5
        })
        if (response && response.detail) {
          this.lstFiveStallRes = response.detail.outputParams
          if (this.lstFiveStallRes) {
            this.$emit(
              'onUpdatePrice',
              this.lstFiveStallRes.buying[0].price,
              this.lstFiveStallRes.selling[0].price
            )
          }
        }
      } else {
        this.lstFiveStallRes = null
      }
    },
    zxjFormat(item) {
      if (!item || item.price === undefined || isNaN(item.price)) {
        return '--'
      }
      return this.isJJ
        ? (item.price / 10000).toFixed(3) + ''
        : (item.price / 10000).toFixed(2) + ''
    },
    countFormat(item) {
      if (!item || item.volume === undefined || isNaN(item.volume)) {
        return '-'
      }
      return parseInt(item.volume / 100)
    },
    updateGoodsId(goodsId, lastPrice, isJJ) {
      this.stockid = goodsId
      this.lastclose = lastPrice
      this.isJJ = isJJ
      this.getFiveStallRes()
    },
    reset() {
      this.stockid = 0
      this.lstFiveStallRes = {}
    },
    buySaleClick(item) {
      if (item && item.price) {
        this.$emit('onItemSlected', item.price)
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  width: 246px;
  height: 304px;
  background-color: #fafafa;
  border-radius: 5px;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.list {
  display: flex;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #858585;
  flex-direction: column;
  flex: auto;
}
.list-split {
  flex-basis: 1px;
  background-color: #ebebeb;
  margin: 10px 0px 10px 0px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: auto;
  cursor: pointer;
}

.cell {
  flex: none;
  text-align: right;
}

.cell:nth-child(2),
.cell:last-child {
  flex-basis: 60px;
}
</style>
